import store from "../store";
import usuario from "@/services/usuario";

export default async (to, from, next) => {
  if (to.fullPath === "/logout") {
    store.dispatch("logout");
    next("/");
    return;
  }
  
  store.dispatch('desconto', {val: false});
  /*if (to.fullPath.includes("/cliente/cursos") || to.fullPath.includes("/funcionario")) {
    store.dispatch('desconto', {val: true});
  }*/
  await store.dispatch("init");
  if (to.fullPath === "/devedor" && !store.getters.user) {
    next();
    return;
  }
  if (to.fullPath === "/devedor" && store.getters.user) {
    next("/funcionario/agenda");
    return;
  }
  if (to.fullPath !== "/" && !store.getters.user) {
    next("/");
    return;
  }
  if (to.fullPath === "/" && !store.getters.user) {
    next();
    return;
  }
  
  if (store.getters.user) {
    let res = await usuario.getUsuario(store.getters.user._id);
    if (!res) {
      store.dispatch("logout");
    }
    if (res.acesso == "Devedor") {
      if (to.fullPath.includes("/minhas-dividas")) {
        next();
        return;
      } else {
        next("/minhas-dividas");
        return;
      }
    }
    if (res.acesso == "Funcionario") {
      if (to.fullPath.includes("/recebimentos")) {
        next();
        return;
      } else if (to.fullPath.includes("/chat")) {
          next();
          return;
      } else if (!to.fullPath.includes("/funcionario")) {
        next("/funcionario/agenda");
        return;
      } else {
        next();
        return;
      }
      
    } 
    
    if (res.acesso == "Cliente") {
      if (to.fullPath.includes("/recebimentos")) {
        next();
        return;
      } else if (to.fullPath.includes("/chat")) {
          next();
          return;
      } else if (to.fullPath.includes("/dividas")) {
        next();
        return;
      } else if (to.fullPath.includes("/painel")) {
        next();
        return;
      } else {
        next("/recebimentos");
        return;
      }
      
    } 
    if (res.grand == "Admin") {
      if (to.fullPath == "/") {
        next("/painel");
        return;
      } else {
        next();
        return;
      }
    }
    if (res.acesso == "AdminClientes") {
      if (to.fullPath == "/") {
        next("/painel");
        return;
      } else {
        next();
        return;
      }
    }
    if (store.getters.user) {
      if (to.fullPath == "/") {
        next("/funcionario/agenda");
        return;
      } else {
        next();
        return;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/router/auth-guard.js